<template>
  <div class="demo">
    <div class="demo__wrapper">
      <div class="demo__wrapper__top-content">
        <top />
      </div>
      <div class="demo__wrapper__middle-content">
        <iframe
          :src="`https://gatoradar.gatoreviews.com/${uuid}?locale=${$i18n.locale}${getParametersView}`"
          class="demo__wrapper__middle-content__iframe"
        ></iframe>
      </div>
      <div class="demo__wrapper__bottom-content">
        <bottom />
      </div>
    </div>
  </div>
</template>

<script>
import Bottom from '@/components/Bottom.vue'
import Top from '@/components/Top.vue'
import { mapActions } from 'vuex'

export default {
  name: 'Demo',
  components: {
    Bottom,
    Top,
  },
  mounted() {
    const locale = this.$route.query.locale
    if (locale) {
      this.$i18n.locale = locale
      this.updateLocale(locale)
    }
  },
  computed: {
    uuid() {
      let token = this.$route.params.token
      if(token){
       return decodeURIComponent(escape(window.atob(token)))
      }
      return '130f7d8c-893b-11ea-93ac-6def7c3e09cd'
    },
    getParametersView() {
      let view = this.$route.query.view
      if(!view) {
        return '&view=demo'
      }
      return `&view=${view}`
    }
  },
  methods: {
    ...mapActions({
      updateLocale: 'bot/updateLocale',
    }),
  },
}
</script>

<style lang="scss">
$top-height: 62px;
$bottom-height: 40px;

.demo {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: $generic-color-bg-disabled;
  overflow: hidden;

  &__wrapper {
    display: flex;
    flex-wrap: wrap;

    &__top-content {
      @include wrapper(flex-start, 0);

      display: flex;
      justify-content: center;
      height: $top-height;
    }

    &__middle-content {
      @include wrapper(center, 0);

      top: $top-height;
      bottom: calc(#{$bottom-height} + #{$gutter-sm * 2});

      @media (min-width: $screen-sm) {
        bottom: calc(#{$bottom-height} + #{$gutter-md * 2});
      }

      &__iframe {
        border: 0;
        width: 100%;
        height: 100%;
      }
    }

    &__bottom-content {
      @include wrapper(flex-start);

      display: flex;
      justify-content: center;
      bottom: 0;
      top: initial;
      height: calc(#{$bottom-height} + #{$gutter-sm * 2});

      @media (min-width: $screen-sm) {
        height: calc(#{$bottom-height} + #{$gutter-md * 2});
      }
    }
  }
}
</style>
